import CourseCompletionRateComparisonTable from 'widgets/CourseCompletionRateComparisonTable/CourseCompletionRateComparisonTable'

export default CourseCompletionRateComparisonTable
